"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProductLine;
(function (ProductLine) {
    ProductLine["AuctionCom"] = "auctioncom";
    ProductLine["SmartSale"] = "smartsale";
})(ProductLine || (ProductLine = {}));
exports.default = ProductLine;
//# sourceMappingURL=productLine.js.map